'use strict'
exports.default = {
  common: {
    zh: '简体中文',
    tw: '繁體中文',
    ja: '日本語',
    en: 'English',
    ko: '한국어',
    title: '后台管理系统',
    exit: '退出'
  },
  title: {
    popularCities: '熱門城市管理',
    addHotCity: '添加熱門城市',
    editHotCity: '編輯熱門城市',
    bannerManage: '橫幅管理'
  },
  lable: {
    translation: 'AI翻译',
    translationing: 'AI翻译中...',
    translationTip: '无可翻译数据',
    isOnline: '是否上架',
    hotCity: '熱門城市',
    cityName: '城市名稱',
    cityPicture: '城市圖片',
    picture: '圖片',
    languageType: '語言',
    sort: '排序',
    sortTip: '數值越小越靠前',
    onlineTip: '下架後不顯示客戶端',
    hotType: '熱門類型',
    type1: '熱門地區',
    type2: '熱門目的地',
    type3: '熱門地標',
    addProduct: '添加商品',
    productInformation: '產品信息',
    price: '價格',
    tags: '標籤',
    productList: '產品列表',
    bannerTitle: '橫幅主標題',
    bannerSubTitle: '橫幅副標題',
    bannerImages: '橫幅圖片'
  },
  viewMessage: {
    hotCity_message2: '請輸入城市名稱',
    hotCity_message19: '長度在 1 到 200 個字符',
    hotCity_remark_placeholder: '請輸入備註',
    banner_save_success: '保存橫幅成功！',
    banner_save_error: '保存橫幅失敗！'
  },
  menu: {
    popularCities: '熱門城市管理',
    banner: '橫幅管理',
    recommendedAttractions: '首页推荐管理'
  },
  newHome: {
    priceFormat: '{0} <span class="price-format">起</span>',
    expired: '登录过期，请重新登录',
    heroTitle: '探索精彩日本',
    heroSubtitle: '發現東京、京都、大阪的獨特魅力與體驗',
    searchPlaceholder: '搜索全球目的地/活動',
    searchButton: '搜索',
    searchResults: '項搜尋結果可預訂',
    category: {
      transport: '交 通',
      themePark: '票 卷',
      wifi: 'WiFi & SIM卡',
      carRental: '优惠套票',
      dayTrip: '一日游 & 多日游',
      hotel: '体验 & 美食'
    },
    productSaleLabel: {
      osakaSalesOffice: '大阪营业所',
      tokyoSalesOffice: '东京营业所',
      fukuokaSalesOffice: '福冈营业所',
      kyotoSalesOffice: '冲绳营业所',
      nagoyaSalesOffice: '名古屋营业所',
      hokkaidoSalesOffice: '北海道营业所'
    },
    popularCities: '熱門城市',
    popularCitiesEn: 'Popular Cities',
    balance: '餘額',
    switchToOldVersion: '切換到舊版',
    switchToNewVersion: '切換到新版',
    username: '用戶名',
    simplifiedChinese: '簡體中文',
    viewMore: '查看更多',
    all: '全部',
    subwayTransport: '地鐵交通&票',
    attractionTickets: '景點門票',
    dayTours: '日遊',
    more: '更多',
    sortBy: '排序',
    easyGoRecommend: 'EasyGo推薦',
    today: '今日',
    tomorrow: '明日',
    allDates: '日期',
    priceRange: '價格範圍',
    other: '其他',
    autoConfirm: '立即確認',
    secondConfirm: '人工確認',
    selectedExperiences: '精選必玩體驗',
    topActivities: '日本最受旅客歡迎的 Top 活動',
    sales: '銷量',
    price: '價格',
    availableDate: '可訂',
    instantConfirm: '立即確認',
    mostPopular: '最受歡迎',
    expressIssuance: '極速出',
    stockQuery: '庫存現詢',
    noProducts: '暂无数据',
    salesLessThan1k: '小于1k',
    menu: {
      merchantInfo: '商戶信息',
      orderManagement: '訂單管理',
      batchPurchase: '批量採購管理',
      tocOrderManagement: 'ToC訂單管理',
      rechargeWithdrawal: '充值/提現管理',
      systemManagement: '系統管理',
      notifications: '通知/通告',
      logout: '退出登錄'
    },
    cities: {
      tokyo: '東京',
      osaka: '大阪',
      kyoto: '京都',
      hokkaido: '北海道',
      sapporo: '札幌',
      okinawa: '沖繩',
      nara: '奈良'
    },
    sortOptions: {
      new: '最新發布',
      sales: '銷量最高'
    }
  }
}



// WEBPACK FOOTER //
// ./src/local/zh_tw.js